import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-left-aside',
  templateUrl: './left-aside.component.html',
  styleUrls: ['./left-aside.component.scss']
})
export class LeftAsideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
